<template>
  <div class="dialog dialog-login">
    <div class="dialog-title">{{ $t('Login') }}</div>
    <div class="dialog-main">
      <el-form :model="formData" :rules="rules" ref="loginForm">
        <el-form-item :label="$t('User Name')" class="input-row" prop="username">
          <el-input v-model="formData.username"/>
        </el-form-item>
        <el-form-item :label="$t('Password')" class="input-row" prop="password">
          <el-input type="password" v-model="formData.password"/>
        </el-form-item>
        <button class="primary" @click.prevent="login('loginForm')">{{ $t('Sign in') }}</button>
      </el-form>
    </div>
  </div>
</template>

<script>
import util from '@/util';

export default {
  props: [],
  data: function () {
    return {
      formData: {
        username: '',
        password: ''
      },
      rules: {
        username: [
          {required: true, message: this.$t('Username is require'), trigger: 'change'}
        ],
        password: [
          {required: true, message: this.$t('Password is require'), trigger: 'change'}
        ]
      }
    }
  },
  methods: {
    login(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          });
          this.axios.post('/api/junket/login', this.formData)
            .then((res) => {
                if (res.code !== 200) {
                  this.$message.error(res.msg);
                } else {
                  util.addCookie('userInfo', JSON.stringify(res.data), {path: "/", expires: 12 * 3600});
                  this.$store.commit('login');
                  if (!res.data.pwd_at) {
                    this.$router.push({path: '/reset'});
                  } else {
                    this.$router.push({path: '/reservation'});
                  }
                }
              }
            ).finally(() => {
            loading.close();
          })
        }
      });
    }
  }
}

</script>
